import { Plan, PlanUbp } from "../types";

export const MONTHLY_PRICE_PER_CREDIT = 4;
export const ANNUAL_PRICE_PER_CREDIT = 4; // Currently no PPC discount for annual
export const STANDARD_PRICE_PER_CREDIT_USD = 4;
export const NEW_CUSTOMER_FLEX_PRICE_PER_CREDIT = 6;

export const DEFAULT_UBP: PlanUbp = {
    includedCredits: 0,
    creditCap: "none",
    pricePerCredit: MONTHLY_PRICE_PER_CREDIT
};

export const PLAN_UBP: Record<Plan, PlanUbp> = {
    [Plan.Public]: { includedCredits: 15, creditCap: 15, pricePerCredit: MONTHLY_PRICE_PER_CREDIT },
    [Plan.UbpBasic]: {
        includedCredits: 30,
        creditCap: "none",
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    },
    [Plan.UbpCore]: {
        includedCredits: 15,
        creditCap: "none",
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    },
    [Plan.UbpGrowth]: {
        includedCredits: 150,
        creditCap: "none",
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    },
    [Plan.UbpPremiumTrial]: {
        includedCredits: 15,
        creditCap: 15,
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    },
    [Plan.EnterpriseGrowth]: {
        includedCredits: 15,
        creditCap: "none",
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    },
    [Plan.Enterprise]: {
        includedCredits: 15,
        creditCap: "none",
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    },
    [Plan.LegacySandbox]: {
        includedCredits: 1,
        creditCap: -1,
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    },
    [Plan.LegacyStarter]: {
        includedCredits: 150,
        creditCap: "none",
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    },
    [Plan.Research]: {
        includedCredits: 50,
        creditCap: 50,
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    },
    [Plan.UninitalizedWorkspace]: {
        includedCredits: 15,
        creditCap: 15,
        pricePerCredit: MONTHLY_PRICE_PER_CREDIT
    }
} as any;
